import React from 'react';
import cn from 'classnames';

import styles from './SortSelect.module.scss';
import Select, { components } from 'react-select';
import { FiGlobe } from 'react-icons/fi';

const SortSelect = ({
  options,
  selected,
  defaultSelected,
  onChange,
  label,
  placeholder,
}) => {

  return (
    <Select
      instanceId="superSelect"
      styles={{
        control: (styles) => ({
          ...styles,
          border: 'none',
          boxShadow: 'none',
          width: '100%',
          backgroundColor: 'transparent',
          cursor: 'pointer',
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        menu: (styles) => ({
          ...styles,
          boxShadow: '2px 0px 6px 5px rgba(235,228,228,0.75)',
          minWidth: 200,
          borderRadius: 12,
          overflow: 'hidden',
        }),
        singleValue: (styles) => ({
          ...styles,
          fontSize: 14,
        }),
        option: (styles, state) => ({
          ...styles,
          fontSize: 14,
          backgroundColor: state.isSelected ? '#536DFE' : 'none',
        }),
        placeholder: (styles) => ({
          ...styles,
          fontSize: 14,
          color: '#000'
        }),
        dropdownIndicator: (styles) => ({ ...styles, display: 'none' })
      }}
      components={{
        SingleValue: (props) => (
          <components.SingleValue {...props}>
            {label}: {props.children}
          </components.SingleValue>
        ),
        Placeholder: (props) => (
          <components.Placeholder {...props}>
            {placeholder}
          </components.Placeholder>
        ),
      }}
      onChange={onChange}
      isSearchable={false}
      defaultValue={defaultSelected}
      value={selected}
      options={options}
    />
  );
};

export default SortSelect;
